/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
// import API_URLS from "src/config/API_URLS";
// import moment from "moment";
import moment from "moment";
import API_URLS from "src/config/API_URLS";
import { CoverType } from "src/config/constant";
import axiosInstance from "src/utils/Axios/axiosInstance";

export const loanDetailsUpdate = async ({ values, section, leadId, masterPolicyNumber }: any) => {
  const { jointCoBorrowerFlag, jointGuarantorFlag, jointHousewifeFlag, jointPrimaryBorrowerFlag } =
    values;
  try {
    const isProportionate = values?.plan?.coverOptionCode === CoverType.PROPORTIONATE;
    const reqBody = {
      ...(section === "loan"
        ? {
            coverOption: values?.loan?.lifeCoverOptionCode,
            loanCategory: values?.loan?.loanTypeCode,
            loanAccountNo: values?.loan?.loanAcNo || null,
            interestPeriod: values?.loan?.interestPeriod.toLowerCase(),
            moratoriumPeriod: Number(values?.loan?.moratoriumPeriodWithCode),
            moratoriumPeriodWithoutInterest: Number(values?.loan?.moratoriumPeriodWithoutCode),
            emiAmount: values?.loan?.emiAmount ? Number(values?.loan?.emiAmount) : null,
            term: Number(values?.loan?.loanTermCode),
            loanAmount: Number(values?.loan?.loanAmount),
            ...(isProportionate && {
              noOfCoBorrowers: Number(values?.loan?.noOfCoBorrowers),
              shareOfLoanPerc: Number(values?.loan?.share)
            }),
            loanInterestRate: Number(values?.loan?.loanInterestRate) || null,
            // loanDisbursementDate: values?.loan?.loanDisbursementDate,
            loanDisbursementDate: moment(values?.loan?.dateOfDisbursement, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            // lipAccountNumber: values?.loan?.lipAccNo,
            lipAccountNumber: values?.loan?.lipAccNo !== "" ? values?.loan?.lipAccNo : null,
            // deathSumAssured: Number(values?.plan?.deathSumInsured),
            policyTerm: Number(values?.plan?.coverTerm),
            premiumPaymentTerm: Number(values?.plan?.premiumPaymentTermCode),
            coverType: values?.plan?.coverOptionCode,
            mode: values?.premiumDetails?.premiumModeCode,
            // totalpremium: values?.premiumDetails?.totalPayment,
            funding: values?.premiumFunding?.premiumFundingCode,
            // sumAssured: Number(values?.loan?.loanAmount)
            ...(!isProportionate && {
              sumAssured: Number(values?.loan?.loanAmount)
            }),
            masterPolicyNumber,
            emiFrequency: values?.loan?.emiFrequency || null,
            lifeAssuredShareOfLoan: values?.loan?.lifeAssuredShareOfLoan || null
          }
        : section === "jointGeneralDetails"
        ? { jointCoBorrowerFlag, jointGuarantorFlag, jointHousewifeFlag, jointPrimaryBorrowerFlag }
        : {
            solId: values.serviceBranchCode,
            bankBranchName: values.serviceBranchName,
            bankCustomerId: values.bankCustomerId || null,
            branchSalesManagerCode: values.branchSalesManagerCode,
            typeOfLoan: values.typeOfLoan,
            st1Code: values.st1Code,
            coBorrowerFlag: values.isCoBorrower,
            guarantorFlag: values.isGuarantor,
            // housewifeFlag: values.isHousewife,
            isPrimaryBorrower: values.isPrimaryBorrower,
            jointcoBorrowerFlag: values.jointCoBorrowerFlag,
            jointguarantorFlag: values.jointGuarantorFlag,
            // jointHousewifeFlag: values.jointHousewifeFlag,
            jointPrimaryBorrowerFlag: values.jointPrimaryBorrowerFlag,
            staff: values.isStaff ? "yes" : "no",
            staffCompany: values.staffCompanyCode || null,
            staffEmpCode: values.staffEmpCode || null,
            st2Code: String(values.staffST2Code) || null,
            masterPolicyNumber: values.masterPolicyNumber || null,
            masterPolicyHolderName: values.masterPolicyHolderName || null,
            assignmentFlag: values.assignmentFlag || false
          })
    };
    const response: any = await axiosInstance.patch(`${API_URLS.leadUrl}${leadId}`, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export const updateExistingPolicyDetails = async ({ memberId, values }: any) => {
  try {
    const reqBody = {
      premiumDetails: values.existingPolicy,
      ...((values.existingPolicy?.existingLifeCover && {
        premiumDetails: values?.existingPolicy
      }) || { premiumDetails: {} })
    };
    const response: any = await axiosInstance.patch(`${API_URLS.setMember}/${memberId}`, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};
